var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"initial-content card-body p-2"},[_c('McAlert',{attrs:{"withIcon":"","variant":"info","text":_vm.$t('fleetTask.transferDeliveryModal.initial.alert')}}),_c('b-row',_vm._l((_vm.typeMapping),function(item){return _c('b-col',{key:item.key,attrs:{"md":"6"}},[_c('button',{class:[
          'type-card',
          'type-card--with-hover-effect',
          {
            'type-card--is-selected': _vm.selectedType == item.key,
          },
        ],on:{"click":() => _vm.$emit('click-card', item.key)}},[_c('i',{class:item.icon}),_c('div',[_c('p',{staticClass:"type-card__title"},[_vm._v(_vm._s(item.title))]),_c('p',{staticClass:"type-card__description mb-0"},[_vm._v(_vm._s(item.description))])])])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }